import React from 'react'
import { getTranslation } from '../translations'

function SectionHeader({ title, subtitle }) {
  return (
    <div className="mb-2">
      <div className="bg-[#134225] text-white font-extrabold px-3 py-2 uppercase tracking-wide text-sm text-center">{title}</div>
      {subtitle ? (
        <div className="text-[12px] italic text-[#334c3e] px-2 py-1 text-center">{subtitle}</div>
      ) : null}
    </div>
  )
}

export default function WaterRecommendation({
  title,
  subtitle,
  corrections = [],
  language = 'english',
}) {
  const t = getTranslation(language)
  
  // Use translations
  const sectionTitle = title || t.waterRecommendationTitle || "Section 2: Water Treatment Recommendations";
  const sectionSubtitle = subtitle || t.waterRecommendationSubtitle || "Suggested corrective measures for your water quality";
  
  const hasValidCorrections = corrections && Array.isArray(corrections) && corrections.length > 0;
  
  if (!hasValidCorrections) {
    return (
      <div className="mt-6">
        <SectionHeader title={sectionTitle} subtitle={sectionSubtitle} />
        <div className="border border-[#cbd9d2] rounded-md overflow-hidden bg-green-50">
          <div className="px-6 py-8 text-center">
            <div className="text-green-800 font-semibold text-lg mb-2">
              {t.waterPerfect || "Water Quality is Optimal"}
            </div>
            <p className="text-green-700 text-sm">
              {t.waterPerfectDesc || "No corrective treatments are required based on the tested parameters."}
            </p>
          </div>
        </div>
      </div>
    )
  }
  
  return (
    <div className="mt-6">
      <SectionHeader title={sectionTitle} subtitle={sectionSubtitle} />
      <div className="mb-3 px-1">
        <p className="text-[13px] font-semibold text-gray-800">
          {t.waterRecommendationNote || "Note: Avoid repeating the same action when it is recommended for multiple parameters. A single practice commonly improves several parameters, so one application is sufficient."}
        </p>
      </div>
      <div className="border border-[#cbd9d2] rounded-md overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-[#134225] text-white text-sm">
              <th className="px-3 py-2 border border-[#d9e4dd] text-left w-1/4">{t.input}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left w-1/4">{t.dose}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.method}</th>
            </tr>
          </thead>
          <tbody>
            {corrections.map((corr, i) => (
              <tr key={i} className="odd:bg-white even:bg-gray-50 text-sm">
                <td className="px-3 py-3 border border-[#e4ebe7]">{corr.input}</td>
                <td className="px-3 py-3 border border-[#e4ebe7] whitespace-pre-wrap">{corr.dose}</td>
                <td className="px-3 py-3 border border-[#e4ebe7] whitespace-pre-wrap">{corr.method}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}